import { merge } from '../../helper';
import insertBefore from '../../general/insertBefore';
import isEmptyArray from '../../general/isEmpty/isEmptyArray';
import isEmptyObject from '../../general/isEmpty/isEmptyObject';

import exLanguage from '../../language';
import * as exButton from '../../components/button';
import * as exElement from '../../utils/element';

import { clear as clearTable } from './clear';
import alreadyTableWrapper from './utils/alreadyTableWrapper';

// ----------------------------------------------------------------------------

function start(element: HTMLElement, config: Record<string, any> = {}): void {
    // Create element (table wrapper)
    const elTableWrapper = alreadyTableWrapper(element);

    // Get element (table button)
    let elTableButton = elTableWrapper.querySelector<HTMLElement>('.table-button');
    // If there is no element (table button)
    if (!elTableButton) {
        // Create element (table button)
        const buttons = create(element, config);
        elTableButton = buttons.element as HTMLElement;
    }

    // ------------------------------------------------------------------------

    // If there is button clear
    if (config.buttonClear === true || !isEmptyObject(config.buttonClear)) {
        const buttonClear = items.clear(element, config.buttonClear);
        elTableButton.appendChild(buttonClear.element);
    }

    // ------------------------------------------------------------------------

    // If there is data
    if (!isEmptyArray(config.data)) {
        // Create buttons
        const listButton = exButton.data(config.data);
        elTableButton.appendChildren(listButton);
    }
}

function create(element: HTMLElement, config: Record<string, any> = {}): Record<string, any> {
    // Default Config
    const defConfig: Record<string, any> = {
        class: {
            new: 'table-button',
        },
    };

    // Merge
    merge(defConfig, config);

    // ------------------------------------------------------------------------

    //
    const elements: Record<string, any> = {};

    // Get element if is table or table scroll
    const elTable = element.closest<HTMLElement>('.table-scroll') ?? element;
    elements.table = elTable;

    // If there is element table
    if (elTable != null) {
        // Get element is table button
        let elTableButton = elTable.querySelector<HTMLElement>('.' + defConfig.class.new);

        // If there is element table button
        if (elTableButton == null) {
            // Create element (table button)
            elTableButton = exElement.create(defConfig);
            insertBefore(elTableButton, elTable);
        }

        elements.element = elTableButton;
    }

    // Return
    return elements;
}

// ----------------------------------------------------------------------------

const items = (function (): any {
    function clear(element: HTMLElement, config: Record<string, any> = {}): Record<string, any> {
        // Default Config
        const defConfig: Record<string, any> = {};

        // Merge
        merge(defConfig, config);

        // --------------------------------------------------------------------

        // Create button
        const button = exButton.create({
            merge: defConfig,
            attr: {
                id: 'btn-clear',
                title: exLanguage.line('general.clean'),
            },
            icon: {
                type: 'fa-regular fa-trash-alt',
            },
            event: {
                mousedown: function (): any {
                    clearTable(element);
                },
            },
        });

        // Return
        return button;
    }

    // ------------------------------------------------------------------------

    return {
        clear,
    };
})();

// ----------------------------------------------------------------------------

export { start, create };
